'use client'

import { CmsContent, getCmsDefaults } from '@dxp/data-access'
import { createContext, useContext } from 'react'

export const CmsContentContext = createContext<CmsContent>(getCmsDefaults())

export const useCmsContext = () => useContext(CmsContentContext)
